import React from "react";
import Chero from "../components/chero";
import Head from "../components/head";
import SICA from "../components/pages/studyincanada/studyincanada";

export default () => {
  return (
    <>
      <Head
        title="Study in Canada"
        dis="Helped a lot with IELTS training and I scored 7.5 bands in just two weeks of training, With help of Steacy Almeida I achieved my goal of 7 bands in IELTS"
      />

      <Chero herotitle="Study in Canada" />
      <SICA />
    </>
  );
};
